import React from "react";
import { Button, Space } from "antd";
import moment from "moment";
import { ColumnType } from "antd/lib/table/interface";
import { SortOrder } from "antd/es/table/interface";
import { DATETIME_FORMAT } from "constants/common";
import { EmailDomainListResponse } from "types/dto/response/accessControl";

type Record = EmailDomainListResponse;

interface UseColumnsParams {
  sortOrder: SortOrder;
  canUpdateEmailDomain: boolean;
  canDeleteEmailDomain: boolean;
  onEdit: (record: Record) => void;
  onDelete: (record: Record) => void;
}

const useColumns = ({
  sortOrder,
  canUpdateEmailDomain,
  canDeleteEmailDomain,
  onEdit,
  onDelete,
}: UseColumnsParams): ColumnType<Record>[] => {
  return [
    {
      title: "Domain",
      dataIndex: "emailDomain",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Block registration",
      dataIndex: "blockRegistration",
      width: 180,
      ellipsis: true,
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Block login",
      dataIndex: "blockLogin",
      width: 130,
      ellipsis: true,
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Modified by",
      dataIndex: "modifiedBy",
      width: 220,
      ellipsis: true,
    },
    {
      title: "Modified at",
      dataIndex: "lastModifiedDate",
      width: 200,
      sorter: true,
      defaultSortOrder: "descend",
      sortDirections: ["descend", "ascend", "descend"],
      sortOrder,
      ellipsis: true,
      render: (value) => value && moment(value).format(DATETIME_FORMAT),
    },
    {
      title: "Action",
      dataIndex: "id",
      width: 120,
      ellipsis: true,
      onCell: () => ({ onClick: (e) => e.stopPropagation() }),
      className: "cursor-default",
      render: (_, record) => (
        <Space size={12}>
          {canUpdateEmailDomain && (
            <Button type="link" onClick={() => onEdit(record)} style={{ padding: 0, height: "auto" }}>
              Edit
            </Button>
          )}
          {canDeleteEmailDomain && (
            <Button type="link" danger onClick={() => onDelete(record)} style={{ padding: 0, height: "auto" }}>
              Delete
            </Button>
          )}
        </Space>
      ),
    },
  ];
};

export default useColumns;
